import { styles } from 'consts';
import styled from 'styled-components';

const { background, fontMontserrat, gray, mainBg, progressPlaceholderDark } = styles;

interface IContainerProps {
  isMoving: boolean;
  delta?: number;
  isOpened?: boolean;
  attributes?: number[];
  externalHeight?: number;
  bottomHeight?: number;
}

const Container = styled.div`
  box-sizing: border-box;
  color: ${gray};
  color: ${mainBg};
  font-family: ${fontMontserrat};
  letter-spacing: 0.015625rem;
  z-index: 1;

  @media (min-width: 768px) {
    display: none;
  }
`;

const Wrapper = styled.div`
  padding: 0.2rem 0.75rem 0.5rem;
  display: flex;
  flex-direction: column;
  align-self: center;
  justify-content: space-between;
`;

const WrapperBottom = styled.div`
  display: block;
`;

const ButtonContainer = styled.div<{ isValid: boolean; payButtonWrapperHeight: number }>`
  overflow: hidden;
  height: 0;
  transition: height 400ms ease-in-out;
  position: relative;
  padding-top: 0.5rem;
  padding-bottom: 0.4rem;

  ${props =>
    props.isValid &&
    ` 
      height: ${props.payButtonWrapperHeight}px;
  `}

  button {
    margin-bottom: 0;
  }
`;

const getTransition = (isMoving: boolean) => (!isMoving ? 'bottom 400ms ease-in-out' : 'none');

const WrapperTop = styled(Wrapper).attrs<IContainerProps>(({ isMoving, bottomHeight }) => ({
  bottomHeight,
  isMoving,
  style: {
    bottom: `${bottomHeight}px`,
    transition: getTransition(isMoving),
  },
}))<IContainerProps>`
  background: ${background};
  box-sizing: border-box;
  position: fixed;
  display: flex;
  width: 100%;
  left: 0;
  width: 100%;
  z-index: 1;
  bottom: 0.25rem;
  padding: 0.75rem 1rem 1rem;
`;

const ProgressContainer = styled.div`
  z-index: 1;

  & > div {
    z-index: 1;
  }
`;

const BottomContainer = styled.div.attrs<IContainerProps>(({ isOpened, isMoving, bottomHeight }) => ({
  isOpened,
  isMoving,
  bottomHeight,
  style: {
    bottom: `${bottomHeight}px`,
    transition: getTransition(isMoving),
  },
}))<IContainerProps>`
  border-top: 1px solid ${progressPlaceholderDark};
  bottom: 0.25rem;
  display: block;
  position: fixed;
  z-index: 1;
  background: ${background};
  bottom: -10rem;
  width: 100%;
  left: 0;
  padding: 0;

  .payment-button-save_instrument-wrapper {
    margin-top: 0.625rem;
  }

  .payment-button-save_instrument-description {
    padding-top: 0.125rem;
  }

  .payment-button-save_instrument-description {
    font-size: 0.9rem;
  }
`;

const PayButtonWrapper = styled(Wrapper)``;

export {
  Container,
  BottomContainer,
  ButtonContainer,
  Wrapper,
  WrapperTop,
  WrapperBottom,
  ProgressContainer,
  PayButtonWrapper,
};
